import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { userIdentity } from './userIdentity';
import { dialogForm } from './dialogForm';

// Modules
import { loader } from './modules/loader';
import { basicData } from './modules/basicData';
import VueMaterial from 'vue-material';
import httpStore from '@/modules/store/store';

Vue.use(Vuex);

Vue.use(VueMaterial);

const dataPersistance = createPersistedState({
  paths: ['userIdentity'],
});

export default new Vuex.Store({
  modules: {
    userIdentity,
    loader,
    basicData,
    dialogForm,
    httpStore,
  },
  plugins: [dataPersistance],
});
